import { SerializedEditorState } from 'lexical';

export const isSerializedEditorState = (
  a: unknown
): a is SerializedEditorState => {
  return typeof a === 'object' && a !== null && 'root' in a;
};
